// ABOUTME: Standalone "expected inbounds" list (relation -> count) for embedding in a BI dashboard cell.
// ABOUTME: Self-fetching: runs its own day-totals inbounds query; `sx` is merged into the root for restyling.
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../../theme";
import Subheading from "../../../../../components/theme/text/Subheading";
import Text from "../../../../../components/theme/text/Text";
import { useGetDaytotalsQuery } from "../../../../../newapi/inbound/inboundsSlice";

export const DaytotalsExpectedInbounds = ({ sx, preview }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const { data: inboundData } = useGetDaytotalsQuery(undefined, { pollingInterval: 300000, skip: preview });

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                ...sx,
            }}
        >
            <Subheading sx={{ mb: 1 }}>{t("expected_inbounds")}</Subheading>
            {inboundData && Array.from(inboundData, (e) => (
                <Box
                    key={e.relationId}
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: 'center',
                        background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        border: `1px solid ${colors.grey[100]}`,
                        boxShadow: `0px 2px 4px ${colors.grey[200]}`,
                        borderRadius: 4,
                        py: 1,
                        pr: 1,
                        pl: 2,
                    }}
                >
                    <Text>{e.relationName}</Text>
                    <Box
                        sx={{
                            height: 32,
                            width: 32,
                            borderRadius: 2,
                            background: colors.grey[100],
                            display: "flex",
                            justifyContent: "center",
                            alignItems: 'center',
                            color: theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                            fontFamily: "Roboto, sans-serif",
                            fontSize: 17,
                            fontWeight: "bold",
                        }}
                    >
                        <Subheading>{e.count}</Subheading>
                    </Box>
                </Box>
            ))}
        </Box>
    );
};
